import j from "./_includes.mjs";
import c from "./_map.mjs";
import u from "./_quote.mjs";
import m from "./_toISOString.mjs";
import f from "../keys.mjs";
import b from "../reject.mjs";
function l(t, s) {
  var e = function(o) {
    var r = s.concat([t]);
    return j(o, r) ? "<Circular>" : l(o, r);
  }, a = function(n, o) {
    return c(function(r) {
      return u(r) + ": " + e(n[r]);
    }, o.slice().sort());
  };
  switch (Object.prototype.toString.call(t)) {
    case "[object Arguments]":
      return "(function() { return arguments; }(" + c(e, t).join(", ") + "))";
    case "[object Array]":
      return "[" + c(e, t).concat(a(t, b(function(n) {
        return /^\d+$/.test(n);
      }, f(t)))).join(", ") + "]";
    case "[object Boolean]":
      return typeof t == "object" ? "new Boolean(" + e(t.valueOf()) + ")" : t.toString();
    case "[object Date]":
      return "new Date(" + (isNaN(t.valueOf()) ? e(NaN) : u(m(t))) + ")";
    case "[object Map]":
      return "new Map(" + e(Array.from(t)) + ")";
    case "[object Null]":
      return "null";
    case "[object Number]":
      return typeof t == "object" ? "new Number(" + e(t.valueOf()) + ")" : 1 / t === -1 / 0 ? "-0" : t.toString(10);
    case "[object Set]":
      return "new Set(" + e(Array.from(t).sort()) + ")";
    case "[object String]":
      return typeof t == "object" ? "new String(" + e(t.valueOf()) + ")" : u(t);
    case "[object Undefined]":
      return "undefined";
    default:
      if (typeof t.toString == "function") {
        var i = t.toString();
        if (i !== "[object Object]")
          return i;
      }
      return "{" + a(t, f(t)).join(", ") + "}";
  }
}
export {
  l as default
};
